// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__1VMqu","tab":"Tabs_tab__v2phJ","tabList":"Tabs_tabList__+WcgB","tab-value":"Tabs_tab-value__irdlL","tab-value-selected":"Tabs_tab-value-selected__F4svV"};